import React from 'react';
import { FormGroup, Label, Input } from 'reactstrap';
import TextStyleInputs from './TextStyleInputs';

const CountdownTab = ({ countdown = {}, updateLocalCountdownConfig }) => {
    return (
        <div>
            {/* Section: Layout */}
            <div className="mb-4">
                <h2 className="h6 text-uppercase text-muted fw-bold border-bottom pb-2 mb-3">Layout</h2>
                <FormGroup switch className="mb-3">
                    <Input
                        type="switch"
                        id="isCountdownFullWidth"
                        checked={countdown.isFullWidth || false}
                        onChange={(e) => updateLocalCountdownConfig({ isFullWidth: e.target.checked })}
                    />
                    <Label check for="isCountdownFullWidth">
                        Volle Breite für Countdown
                    </Label>
                </FormGroup>
            </div>

            <div className="mb-4">
                <h2 className="h6 text-uppercase text-muted fw-bold border-bottom pb-2 mb-3">Countdown-Typografie</h2>
                <TextStyleInputs
                    label="Countdown-Textstil"
                    styleConfig={countdown.textStyle}
                    onChange={(style) => updateLocalCountdownConfig({ textStyle: style })}
                />
                <FormGroup className="mb-3">
                    <Label for="countdownPadding">Abstand / Padding (z.B. 1rem 2rem, 12px)</Label>
                    <Input
                        type="text"
                        id="countdownPadding"
                        value={countdown.padding || ''}
                        onChange={(e) => updateLocalCountdownConfig({ padding: e.target.value || undefined })}
                        placeholder="Standard (z.B. 0.5rem 1rem)"
                    />
                </FormGroup>
                <FormGroup className="mb-3">
                    <Label for="countdownVariant">Countdown-Variante (Stil)</Label>
                    <Input
                        type="select"
                        id="countdownVariant"
                        value={countdown.variant || 'solid'}
                        onChange={(e) => updateLocalCountdownConfig({ variant: e.target.value })}
                    >
                        <option value="solid">Vollflächiger Hintergrund (Solid)</option>
                        <option value="border-bottom">Nur Rahmen unten (Border Bottom)</option>
                    </Input>
                </FormGroup>
                <FormGroup className="mb-3">
                    <Label for="countdownColorTheme">Farbschema (Theme Color)</Label>
                    <Input
                        type="select"
                        id="countdownColorTheme"
                        value={countdown.colorTheme || 'primary'}
                        onChange={(e) => updateLocalCountdownConfig({ colorTheme: e.target.value })}
                    >
                        <option value="primary">Primärfarbe (Primary)</option>
                        <option value="secondary">Sekundärfarbe (Secondary)</option>
                    </Input>
                </FormGroup>
            </div>
        </div>
    );
};

export default CountdownTab;
